import React from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import { generateReport,
  clearPositionBook,
  updateDate,
  generateProductReport,
  tradesProfitability as tradesProfitabilityFunc,
} from './store/OpenPosition.store';
import FromToDatePickers from '../../form/FromToDateHorizontalPickers';
import { Row, Col, Button, Checkbox } from 'react-bootstrap';
import { MainComponentBox, reportFormatter, productNameFromLowerCase } from '@/util/util.jsx';
import { Map, List } from 'immutable';
import { formatNumber } from '../deals/elements/BaseElement';
import { BarChart, LineChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList,
  ComposedChart, Line, ResponsiveContainer } from 'recharts';
import { highlightChartZero, resetChartLines } from './Profitability';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import FontAwesome from 'react-fontawesome';
import momentLocalizer from 'react-widgets-moment';
import moment from 'moment';
import './reports.less';
import xls from '@/../style/xls.png';
import pdf from '@/../style/pdf.png';
import refresh from '@/../style/refresh.png';

import { fixDate } from '../../../util/util';
moment.locale('en');
momentLocalizer();

const tdStyleCommon = { border: 0 };
const purchaseColumn = { ...tdStyleCommon, color: 'blue' };
const saleColumn = { ...tdStyleCommon, color: 'red' };

const productColors = {
  urea: '#4198AF',
  nitrate: '#89A54E',
  phosphates: '#71588F',
  potash: '#AA4643',
  npks: '#4572A7',
  agri: '#DB843D',
  sulfur: '#28d826',
  solubles: '#93A9CF',
  sulfate: '#5c2bc9',
  other: '#D19392',
};

export const RefreshButton = (props) => <Button
  {...props}
  className={'export-button'}
><img src={refresh} alt={'Refresh'} />
  <span>Refresh</span>
</Button>;
export const XlsExportButton = (props) => <Button
  {...props}
  className={'export-button'}
><img src={xls} alt={'Export to Excel'} />
  <span>.XLS</span>
</Button>;
export const PdfExportButton = (props) => <Button
  {...props}
  className={'export-button'}
><img src={pdf} alt={'Export to pdf'} />
  <span>.PDF</span>
</Button>;


const withArrow = (name, hasArrow) => {
  if (hasArrow) {
    return (
      <div>
        {name} <FontAwesome name="caret-down" />
      </div>
    );
  }
  return name;
};

// eslint-disable-next-line
export class OverlineLabel extends React.Component {
  render() {
    const {x, y, stroke, format, value, prefix} = this.props; // eslint-disable-line
    const formatter = format || reportFormatter;
    return (<text x={x} y={y} dy={-10} fill={stroke} fontSize={14} textAnchor="middle">
      {`${prefix || ''}${formatter(value)}`}
    </text>);
  }
}

const cutString = (value) => {
  if (value.length > 18) {
    return `${value.substring(0, 16)}...`;
  }
  return value;
};
const labelFormatter = (val) => {
  if (val == 0) {
    return '';
  }
  return reportFormatter(val);
};

const quantityFormat = '0.[0]a';

export const tooltipContent = mappedFormats =>
// eslint-disable-next-line
  (...args) => mappedFormats.hasOwnProperty(args[1])
    ? formatNumber(args[0], mappedFormats[args[1]]) : args[0];

export const getTickInfo = (data, profitField = 'Profitability', blField = 'B\\L quantity') => {
  let maxProfit = 0;
  let minProfit = 0;
  let minBL = 0;
  let maxBL = 0;
  let profitTicks;
  let blTicks;
  if (data && data.length) {
    data
      .forEach(elem => {
        minProfit = elem[profitField] && elem[profitField] < minProfit ?
          elem[profitField] : minProfit;
        maxProfit = elem[profitField] && elem[profitField] > maxProfit ?
          elem[profitField] : maxProfit;
        maxBL = elem[blField] && elem[blField] > maxBL ?
          elem[blField] : maxBL;
      });
    minBL = minProfit < 0 ? maxBL / (maxProfit / Math.abs(minProfit)) * -1 : 0;
    minProfit = minProfit * 1.1;
    maxProfit = maxProfit * 1.1;
    minBL = minBL * 1.1;
    maxBL = maxBL * 1.1;
    if (maxProfit && maxBL) {
      const totalProfit = maxProfit + Math.abs(minProfit);
      const totalBL = maxBL + Math.abs(minBL);
      const totalTicks = 4;
      profitTicks = [];
      blTicks = [];

      let zeroAdded = false;
      for (let i = 0; i < totalTicks; i++) {
        const newProfitTick = minProfit + totalProfit / (totalTicks - 1) * i;
        const newBLTick = minBL + totalBL / (totalTicks - 1) * i;
        if (minProfit < 0 && !zeroAdded && newProfitTick > 0) {
          profitTicks.push(0);
          blTicks.push(0);
          zeroAdded = true;
        }
        profitTicks.push(newProfitTick);
        blTicks.push(newBLTick);
      }
    }
  }
  return { maxProfit, minProfit, maxBL, minBL, profitTicks, blTicks };
};

// eslint-disable-next-line
class OpenPositionClass extends React.Component {

  constructor(props) {
    super(props);
    this.generateReport = this.generateReport.bind(this);
    this.generateProfitReport = this.generateProfitReport.bind(this);
    this.renderTable = this.renderTable.bind(this);
    this.expandableRow = this.expandableRow.bind(this);
    this.reload = this.reload.bind(this);
    this.weeklyChartLegend = this.weeklyChartLegend.bind(this);
    this.productGroupColumnClassNameFormat = this.productGroupColumnClassNameFormat.bind(this);
    this.state = { weeklySelected: { urea: true, nitrate: true, phosphates: true } };
  }

  componentWillMount() {
    if (!this.props.subGroup) {
      this.generateReport(this.props.dateFrom, this.props.dateTo);
      // this.props.generateProductReport();
    }
  }

  componentDidMount() {
    $().ready(() => {
      highlightChartZero('weekly');
      highlightChartZero('profitability');
    });
  }

  componentWillReceiveProps(props) {
    if (!this.props.subGroup && props.done) {
      const data = props.data.map(d =>
        d.set('subGroupItems', d.get('subGroupItems').map(sub => this.formatItem(sub))),
      ).map(d => this.formatItem(d)).toJS();
      const UREA = data.find(d => d.productGroup === 'urea');
      const Nitrate = data.find(d => d.productGroup === 'nitrate');
      const Phosphates = data.find(d => d.productGroup === 'phosphates');
      const Potash = data.find(d => d.productGroup === 'potash');
      const NPKs = data.find(d => d.productGroup === 'npks');
      const AGRI = data.find(d => d.productGroup === 'agri');
      const Sulfur = data.find(d => d.productGroup === 'sulfur');
      const Sulfate = data.find(d => d.productGroup === 'sulfate');
      const Solubles = data.find(d => d.productGroup === 'solubles');
      const Other = data.find(d => d.productGroup === 'other');
      this.data = [
        UREA, Nitrate, Phosphates, Potash, NPKs, AGRI, Sulfur, Solubles, Sulfate, Other,
      ].filter(p => p);

      this.dataWeekly = [];
      props.dataWeekly.forEach((v, k) => {
        this.dataWeekly.push({
          date: moment(k),
          name: moment(k).format('MMM DD'),
          ...v.toJS(),
        });
      });
      this.dataWeekly.sort((a, b) => moment(a.date).unix() - moment(b.date).unix());
      this.tradesConcluded = [];
      props.tradesConcluded.forEach((v, k) => {
        this.tradesConcluded.push({
          date: moment(k),
          name: moment(k).format('MMMM'),
          Purchase: v.toJS()[0],
          Sales: v.toJS()[1],
        });
      });
      this.tradesConcluded.sort((a, b) => moment(a.date).unix() - moment(b.date).unix());
      this.tradesProfitability = [];
      props.tradesProfitability.forEach((v, k) => {
        this.tradesProfitability.push({
          date: moment(k),
          name: moment(k).format('MM.YYYY'),
          Profitability: v.toJS()[0] ? v.toJS()[0] : null,
          'B\\L quantity': v.toJS()[1],
        });
      });
      this.tradesProfitability.sort((a, b) => moment(a.date).unix() - moment(b.date).unix());
    }
  }

  componentWillUnmount() {
    resetChartLines();
    if (!this.props.subGroup) {
      this.props.clearPositionBook();
    }
  }

  reload() {
    this.props.clearPositionBook();
    this.data = [];
    this.generateReport(this.props.dateFrom, this.props.dateTo);
    // this.props.generateProductReport();
  }

  formatShipment(item, fromName, toName) {
    let shipmentFrom = item.get(fromName);
    let shipmentTo = item.get(toName);

    shipmentFrom = shipmentFrom ? moment(shipmentFrom, 'DD MMM YYYY').format('MMM') : '';
    shipmentTo = shipmentTo ? moment(shipmentTo, 'DD MMM YYYY').format('MMM') : '';
    if (shipmentFrom == shipmentTo) {
      return shipmentFrom || '';
    }
    if (!shipmentFrom) {
      return shipmentTo;
    }
    if (!shipmentTo) {
      return shipmentFrom;
    }
    return `${shipmentFrom}-${shipmentTo}`;
  }

  formatItem(item) {
    const longPricePosifix = item.get('hasFormulaPriceLong') ? '*' : '';
    const shortPricePostfix = item.get('hasFormulaPriceShort') ? '*' : '';
    return item.set('longDates', this.formatShipment(item, 'longDateFrom', 'longDateTo'))
      .set('shortDates', this.formatShipment(item, 'shortDateFrom', 'shortDateTo'))
      .set('longPrice',
        `$${reportFormatter(item.get('longPrice'))}${longPricePosifix}`)
      .set('shortPrice',
        `$${reportFormatter(item.get('shortPrice'))}${shortPricePostfix}`)
      .set('longQuantity', `${reportFormatter(item.get('longQuantity'))}`)
      .set('shortQuantity', `${reportFormatter(item.get('shortQuantity'))}`);
  }

  generateReport(dateFrom, dateTo) {
    this.props.generateReport(dateFrom, dateTo);
  }
  generateProfitReport() {
    resetChartLines();
    this.props.tradesProfitabilityFunc(this.props.dateFrom, this.props.dateTo).then(
      () => highlightChartZero('profitability'));
  }

  columnClassNameFormat(fieldValue, row, rowIdx) {
    return rowIdx % 2 === 0 ? 'openposition-td-column-even-example' :
      'openposition-td-column-odd-example';
  }

  productGroupColumnClassNameFormat(fieldValue, row, rowIdx) {
    return `openposition-td-column-product ${this.columnClassNameFormat(fieldValue, row, rowIdx)
    } ${this.expandableRow(row) ? 'pointer' : ''}`;
  }

  expandComponent(row) {
    return (
      <div>
        <OpenPosition subGroup productGroup={row.productGroup} data={row.subGroupItems} />
      </div>);
  }

  overallFormatter(value) {
    if (value > 0) {
      return (<div style={{ ...purchaseColumn, fontWeight: 'bold' }}>
        {reportFormatter(Math.abs(value))}</div>);
    } else if (value < 0) {
      return (<div style={{ ...saleColumn, fontWeight: 'bold' }}>
        {reportFormatter(Math.abs(value))}</div>);
    }
    return (<div style={{ fontWeight: 'bold', color: '#000' }}>0</div>);
  }

  overallValueFormatter(value) {
    if (value > 0) {
      return (<div style={{ ...purchaseColumn, fontWeight: 'bold' }}>
        ${reportFormatter(Math.abs(value))}</div>);
    } else if (value < 0) {
      return (<div style={{ ...saleColumn, fontWeight: 'bold' }}>
        ${reportFormatter(Math.abs(value))}</div>);
    }
    return (<div style={{ fontWeight: 'bold', color: '#000' }}>$0</div>);
  }

  weeklyChartLegend(props) {
    const renderCell = (text, selected, color, tdStyle) => (
      <td style={tdStyle} className={'open-positions-weekly-legend-item'}>
        <div style={{ border: `1px solid ${color}`, borderRadius: '3px' }}>
          <Checkbox
            checked={selected}
            style={{ paddingLeft: '2px', paddingTop: '2px', paddingRight: '5px', margin: 0 }}
            onChange={() => this.setState({ weeklySelected: {
              ...this.state.weeklySelected,
              [text.toLowerCase()]: !this.state.weeklySelected[text.toLowerCase()] } })}
          >
            {text.toUpperCase()}
          </Checkbox>
        </div>
      </td>
    );
    const tdStyle = { padding: '5px' };
    return (
      <div style={{ width: '100%', textAlign: props.align }}>
        <table style={{ margin: 'auto' }}>
          <tr>
            {renderCell('Urea', this.state.weeklySelected.urea, productColors.urea, tdStyle)}
            {renderCell('Nitrate', this.state.weeklySelected.nitrate,
              productColors.nitrate, tdStyle)}
            {renderCell('Phosphates', this.state.weeklySelected.phosphates,
              productColors.phosphates, tdStyle)}
            {renderCell('Potash', this.state.weeklySelected.potash, productColors.potash, tdStyle)}
            {renderCell('NPKs', this.state.weeklySelected.npks, productColors.npks, tdStyle)}
            {renderCell('AGRI', this.state.weeklySelected.agri, productColors.agri, tdStyle)}
            {renderCell('Sulfur', this.state.weeklySelected.sulfur, productColors.sulfur, tdStyle)}
            {renderCell('Solubles', this.state.weeklySelected.solubles,
              productColors.solubles, tdStyle)}
            {renderCell('Sulfate', this.state.weeklySelected.sulfate,
              productColors.sulfate, tdStyle)}
            {renderCell('Other', this.state.weeklySelected.other, productColors.other, tdStyle)}
          </tr>
        </table>
      </div>
    );
  }

  weeklyChart(dataWeekly) {
    const lines = [];
    Object.keys(this.state.weeklySelected).forEach((key) => {
      if (this.state.weeklySelected[key]) {
        lines.push(<Line
          isAnimationActive={false}
          type="monotone"
          dataKey={key}
          stroke={productColors[key]}
          strokeWidth="4"
          dot={{ strokeWidth: 3, fill: 'white', r: 6 }}
          connectNulls
          // label={
          // <OverlineLabel stroke={productColors[key]} format={this.quantityShortFormatter} />}
        />);
      }
    });
    return (
      <ResponsiveContainer width="100%" height={500}>
        <LineChart
          data={dataWeekly}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <XAxis dataKey="name" />
          <YAxis tickFormatter={this.quantityShortFormatter} />
          <CartesianGrid fill="rgba(182, 182, 182, 0.2)" strokeDasharray="3 3" />
          <Tooltip formatter={value => formatNumber(value, '0,0')} />
          <Legend content={this.weeklyChartLegend} />
          {lines}
        </LineChart>
      </ResponsiveContainer>
    );
  }

  tooltipFormatter(value) {
    return formatNumber(value, '0,0.[000]');
  }

  tradesConcludedChart(tradesConcluded) {
    return (
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          width={600} height={300} data={tradesConcluded}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
        >
          <XAxis dataKey="name" />
          <YAxis tickFormatter={labelFormatter} />
          <CartesianGrid fill="rgba(182, 182, 182, 0.2)" strokeDasharray="3 3" />
          <Tooltip formatter={this.tooltipFormatter} />
          <Legend />
          <Bar
            dataKey="Purchase"
            stackId="a" fill="var(--overview-purchase-bar)"
            isAnimationActive={false}
          >
            <LabelList
              dataKey="Purchase" position="center" fill="white" formatter={labelFormatter}
            />
          </Bar>
          <Bar
            dataKey="Sales" stackId="a" fill="var(--overview-sale-bar)" isAnimationActive={false}
          >
            <LabelList
              dataKey="Sales" position="center" fill="white" formatter={labelFormatter}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  }

  chartValueFormatter(value) {
    return reportFormatter(value);
  }

  quantityShortFormatter(value) {
    return `${formatNumber(value, quantityFormat)}`.toUpperCase();
  }

  tradesProfitabilityChart(tradesProfitability) {
    const tickInfo = getTickInfo(tradesProfitability);
    return (
      <ResponsiveContainer width="100%" height={500}>
        <ComposedChart
          data={tradesProfitability}
          margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
        >
          <CartesianGrid fill="rgba(182, 182, 182, 0.2)" strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis
            domain={tickInfo.maxProfit ? [tickInfo.minProfit, tickInfo.maxProfit] : undefined}
            tick ticks={tickInfo.profitTicks} minTickGap={3}
            yAxisId="profitability"
            orientation="right"
            tickFormatter={v => `$${this.chartValueFormatter(v)}`}
          />
          <YAxis
            tick ticks={tickInfo.blTicks} minTickGap={3}
            domain={tickInfo.maxBL ? [tickInfo.minBL, tickInfo.maxBL] : undefined}
            yAxisId="bl" tickFormatter={reportFormatter}
          />
          <Legend />
          <Tooltip
            formatter={tooltipContent({
              'B\\L quantity': '0,0.[000]',
              Profitability: '$0,0.[00]',
            })}
          />
          <Bar
            yAxisId="bl"
            dataKey="B\L quantity"
            fill="var(--reports-purchase-bar)"
            barSize={30}
            isAnimationActive={false}
          >
             <LabelList
             dataKey="B\L quantity"
             position="top"
             fill="black"
             formatter={v => `${labelFormatter(v)}`}
             />
          </Bar>
          <Line
            yAxisId="profitability"
            type="monotone"
            dataKey="Profitability"
            stroke="var(--reports-sale-bar)"
            strokeWidth="4"
            dot={{ strokeWidth: 3, fill: 'white', r: 6 }}
            isAnimationActive={false}
            // label={<OverlineLabel prefix="$" stroke="#38B8C8" />}
          />
        </ComposedChart>
      </ResponsiveContainer>
    );
  }

  expandableRow(row) {
    const pg = row.productGroup;
    return !this.props.subGroup && pg != 'agri' && pg != 'solubles'
      && pg != 'specialty';
  }

  productGroupFormatter = (value, row) => {
    switch (value) {
      case 'urea': return withArrow('UREA', this.expandableRow(row));
      case 'nitrate': return withArrow('NITRATE', this.expandableRow(row));
      case 'phosphates': return withArrow('PHOSPHATES', this.expandableRow(row));
      case 'potash': return withArrow('POTASH', this.expandableRow(row));
      case 'npks': return withArrow('NPKs', this.expandableRow(row));
      case 'agri': return withArrow('AGRI', this.expandableRow(row));
      case 'sulfur': return withArrow('SULFUR', this.expandableRow(row));
      case 'solubles': return withArrow('SOLUBLES', this.expandableRow(row));
      case 'sulfate': return withArrow('SULFATE', this.expandableRow(row));
      case 'other': return withArrow('OTHER', this.expandableRow(row));
      default: return cutString(value);
    }
  };

  dateRangeSelect() {
    const { dateFrom, dateTo } = this.props;
    return (<div
      style={{ display: 'inline-block',
        marginBottom: '-13px',
        width: '350px',
        textAlign: 'left',
        fontWeight: 'normal',
        height: 34,
        paddingLeft: '15px' }}
    >
      <FromToDatePickers
        bindSelect={false}
        labelStyle={{ display: 'none' }}
        labelChildStyle={{ width: '100%', padding: 0 }}
        defaultValueFrom={dateFrom}
        defaultValueTo={dateTo}
        onChangeFrom={(val) => this.props.updateDate(val, dateTo)}
        onChangeTo={(val) => this.props.updateDate(dateFrom, val)}
      />
    </div>);
  }

  renderAvgDaysOfCarryingReport = (data) => data.map(product => (
    <div className="product__card">
      <div className="product__card--info-name">
        {productNameFromLowerCase(product.get('Product', ''))}
      </div>
      <div className="product__card--info-long">
        {formatNumber(product.get('Long', ''), '0,0.[0]') || '\u00A0'}
      </div>
      <div className="product__card--info-short">
        {formatNumber(product.get('Short', ''), '0,0.[0]') || '\u00A0'}
      </div>
    </div>
  ));

  renderTable(children) {
    if (this.props.subGroup) {
      return children;
    }
    return (<MainComponentBox>
      <div>
        <div className={'report-panel'} style={{ padding: 60 }}>
          <Row>
            <Col md={12}>
              <div>
                <span className={'report-panel-label'}>Open positions - Real Time</span>
                <RefreshButton onClick={this.reload} />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              {children}
              <div>* - several deals have the prices set as formula.
            Therefore, data may be inaccurate.
              </div>
            </Col>
          </Row>
        </div>
        <div className={'report-panel'}>
          <Row>
            <Col md={12}>
              <div>
                <span className={'report-panel-label'}>Trades Concluded (Based on CD)</span>
                <XlsExportButton
                  onClick={() => {
                    window.location =
                    `/api/report/export/openposition?type=concluded`;  //eslint-disable-line
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              {this.tradesConcludedChart(this.tradesConcluded)}
            </Col>
          </Row>
        </div>
        <div className={'report-panel'}>
          <Row>
            <Col md={12}>
              <div>
                <span className={'report-panel-label'}>Open Position YTD (Weekly Data)</span>
                <XlsExportButton
                  onClick={() => {
                    window.location =
                    `/api/report/export/openposition?type=weekly`;  //eslint-disable-line
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={12} id="weekly">
              {this.weeklyChart(this.dataWeekly)}
            </Col>
          </Row>
        </div>
        <div className={'report-panel'}>
          <Row>
            <Col md={12}>
              <div>
                <span className={'report-panel-label'}>
                  Trades & Profitability YTD (Based on BL)
                </span>
                {this.dateRangeSelect()}
                <Button
                  className={'dates-apply-button'}
                  onClick={this.generateProfitReport}
                >
                Generate
                </Button>
                <XlsExportButton
                  onClick={() => {
                    window.location =
                    `/api/report/export/openposition?type=profitability&from=${
                      this.props.dateFrom ? this.props.dateFrom.toDateString() : ''
                    }&to=${this.props.dateTo ? this.props.dateTo.toDateString() : ''}`;
                  }}
                />
              </div>
            </Col>
            <Col md={12} id="profitability">
              {this.tradesProfitabilityChart(this.tradesProfitability)}
            </Col>
          </Row>
        </div>
        { /* <div className={'report-panel'} style={{ width: 'max-content' }}>
          <div>
            <span className={'report-panel-label'}>
              Average Days of Carrying Position (12 months)
            </span>
          </div>
          <div>
            <div className="product__container">
              <div className="product__card">
                <div className="product__card--title-info product__card--info-name ">&nbsp;</div>
                <div className="product__card--title-info product__card--info-long">
                    Long, Days
                </div>
                <div className="product__card--title-info product__card--info-short">
                    Short, Days
                </div>
              </div>
            </div>
          </div>
        </div> */ }
      </div>
    </MainComponentBox>);
  }

  render() {
    const options = {
      expandBy: 'column',
    };
    const thStyle = {
      display: this.props.subGroup ? 'none' : 'table-cell',
      border: 0,
      fontWeight: 'normal',
      borderBottom: '5px solid #DFDFDF',
    };
    return this.renderTable(
      <BootstrapTable
        bordered={false}
        striped
        className="openPosition"
        expandableRow={this.expandableRow}
        expandComponent={this.expandComponent}
        data={this.props.subGroup ? this.props.data : this.data}
        options={options}
      >
        <TableHeaderColumn
          dataField="id"
          isKey={this.props.subGroup}
          hidden
        />
        <TableHeaderColumn
          isKey={!this.props.subGroup}
          dataField="productGroup"
          dataAlign={'right'}
          tdStyle={{
            ...tdStyleCommon,
            fontWeight: 'bold',
          }}
          thStyle={thStyle}
          columnClassName={this.productGroupColumnClassNameFormat}
          dataFormat={this.productGroupFormatter}
        />
        <TableHeaderColumn
          dataField="longQuantity"
          columnClassName={this.columnClassNameFormat}
          thStyle={{ ...thStyle, fontWeight: 'bold' }}
          tdStyle={purchaseColumn}
        >
          LONG
        </TableHeaderColumn>
        <TableHeaderColumn
          thStyle={thStyle}
          tdStyle={purchaseColumn}
          columnClassName={this.columnClassNameFormat}
          dataField="longPrice"
        >
          Value
        </TableHeaderColumn>
        <TableHeaderColumn
          thStyle={thStyle}
          tdStyle={purchaseColumn}
          columnClassName={this.columnClassNameFormat}
          dataField="longDates"
        >
          Shipment
        </TableHeaderColumn>
        <TableHeaderColumn
          thStyle={{ ...thStyle, fontWeight: 'bold' }}
          tdStyle={saleColumn}
          columnClassName={this.columnClassNameFormat}
          dataField="shortQuantity"
        >
          SHORT
        </TableHeaderColumn>
        <TableHeaderColumn
          thStyle={thStyle}
          tdStyle={saleColumn}
          columnClassName={this.columnClassNameFormat}
          dataField="shortPrice"
        >
          Value
        </TableHeaderColumn>
        <TableHeaderColumn
          thStyle={thStyle}
          tdStyle={saleColumn}
          columnClassName={this.columnClassNameFormat}
          dataField="shortDates"
        >
          Shipment
        </TableHeaderColumn>
        <TableHeaderColumn
          thStyle={{ ...thStyle, fontWeight: 'bold' }}
          tdStyle={saleColumn}
          columnClassName={this.columnClassNameFormat}
          dataField="overall"
          dataFormat={this.overallFormatter}
        >
          OVERALL
        </TableHeaderColumn>
        <TableHeaderColumn
          thStyle={thStyle}
          tdStyle={saleColumn}
          columnClassName={this.columnClassNameFormat}
          dataField="overallValue"
          dataFormat={this.overallValueFormatter}
        >
          Overall value
        </TableHeaderColumn>
      </BootstrapTable>,
    );
  }
}

OpenPositionClass.propTypes = {
  data: React.PropTypes.object.isRequired,
  dataWeekly: React.PropTypes.object.isRequired,
  tradesConcluded: React.PropTypes.object.isRequired,
  tradesProfitability: React.PropTypes.object.isRequired,
  done: React.PropTypes.bool,
  generateReport: React.PropTypes.func.isRequired,
  clearPositionBook: React.PropTypes.func.isRequired,
  productGroup: React.PropTypes.string,
  subGroup: React.PropTypes.bool,
  loading: React.PropTypes.bool,
  updateDate: React.PropTypes.func,
  dateFrom: React.PropTypes.number,
  dateTo: React.PropTypes.number,
  productReport: React.PropTypes.object,
  generateProductReport: React.PropTypes.func.isRequired,
  tradesProfitabilityFunc: React.PropTypes.func.isRequired,
};

const OpenPosition = connect(
  (state, props) => ({
    data: props.subGroup ? props.data :
      state.getIn(['data', 'reports', 'openPosition', 'data'], new List()),
    done: state.getIn(['data', 'reports', 'openPosition', 'done'], false),
    loading: state.getIn(['data', 'reports', 'openPosition', 'loading'], false),
    dataWeekly: state.getIn(['data', 'reports', 'openPosition', 'weekly'], new Map()),
    tradesConcluded: state.getIn(['data', 'reports', 'openPosition', 'tradesConcluded'], new Map()),
    dateFrom: state.getIn(['data', 'reports', 'openPosition', 'dateFrom'],
      fixDate(moment().startOf('year').toDate())),
    dateTo: state.getIn(['data', 'reports', 'openPosition', 'dateTo'],
      fixDate(moment().startOf('year').add(1, 'year')
        .toDate())),
    tradesProfitability: state.getIn(['data', 'reports', 'openPosition',
      'tradesProfitability'], new Map()),
    productReport: state.getIn(['data', 'reports', 'openPosition', 'productReport'], new List()),
  }),
  dispatch => ({
    generateReport(dateFrom, dateTo) {
      generateReport(dispatch, dateFrom, dateTo);
    },
    clearPositionBook() {
      clearPositionBook(dispatch);
    },
    updateDate(dateFrom, dateTo) {
      updateDate(dispatch, dateFrom, dateTo);
    },
    generateProductReport() {
      generateProductReport(dispatch);
    },
    tradesProfitabilityFunc(from, to) {
      return tradesProfitabilityFunc(dispatch, from, to);
    },
  }),
)(OpenPositionClass);

export default OpenPosition;
